import './App.css';
import Navbar from './components/Navbar'
import SearchBar from './components/SearchBar'
import UniCounts from './components/UniCounts'
import Filters from './components/Filters'
import UniTable from './components/UniTable'
import GetData from "./data/getData";
import AccordionMenu from './components/AccordionMenu';


import React, { useState } from "react";

function App() {

  const [uniData, setUniData] = useState([]);
  const [searchKey, setSearchKey] = useState("hacettepe");
  const [favDepartments, setFavDepartments] = useState([]);
  const [favoriteDepartmentTrigger, setFavoriteDepartmentTrigger] = useState(0);
  const [resultNumber, setResultNumber] = useState();
  const [filters, setFilters] = useState({
    pointTypes: [],
    minRankRange: 0,
    maxRankRange: 99999999,
    minPointRange: 0,
    maxPointRange: 999,
    cities: [],
    departments: [],
  });

  return (
    <div className="App">
      <GetData
        setUniData={setUniData}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        setResultNumber={setResultNumber}
        filters={filters}
      />
      <Navbar />
      <div className="container container-sm text-center">
        <div className="row">
          <div className="col-12 col-md-3  justify-content-center">
            <UniCounts resultNumber={resultNumber} />
            <Filters filters={filters} setFilters = {setFilters} />
          </div>
          <div className="col-12 col-md">
            <SearchBar searchKey={searchKey} setSearchKey={setSearchKey} />
            <UniTable
              uniData={uniData}
              favDepartments={favDepartments}
              setFavDepartments={setFavDepartments}
              favoriteDepartmentTrigger={favoriteDepartmentTrigger}
              setFavoriteDepartmentTrigger={setFavoriteDepartmentTrigger}
            />
            <AccordionMenu
              favDepartments={favDepartments}
              setFavDepartments={setFavDepartments}
              favoriteDepartmentTrigger={favoriteDepartmentTrigger}
              setFavoriteDepartmentTrigger={setFavoriteDepartmentTrigger}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
